export const SET_SHOW_CATEGORY = 'SET_SHOW_CATEGORY';
export function setShowCategory(showSubCategory) {
    return({
        type:SET_SHOW_CATEGORY, showSubCategory
    });
}

export const SET_USER_INFO = 'SET_USER_INFO';
export function setUserInfo(userInfo) {
    return({
        type:SET_USER_INFO, userInfo
    });
}

export const SET_IS_LOGIN = 'SET_IS_LOGIN';
export function setIsLogin(isLogin) {
    return({
        type:SET_IS_LOGIN, isLogin
    });
}

export const SET_CATEGORY_DATA = 'SET_CATEGORY_DATA';
export function setCategoryData(categoryData){
    return({
        type:SET_CATEGORY_DATA,
        categoryData:categoryData
    });
}


export const SET_BANNER = 'SET_BANNER';
export function setBanner(banner){
    return({
        type:SET_BANNER,
        banner:banner
    });
}

export const SET_MINISHOP = 'SET_MINISHOP';
export function setMiniShopInfo(miniShopInfo) {
    return({
        type:SET_MINISHOP, miniShopInfo
    });
}

export const SET_ITEM_COUNT = 'SET_ITEM_COUNT';
export function setItemCount(itemCount) {
    return({
        type:SET_ITEM_COUNT, itemCount
    });
}


export const SET_MEDIUMGUIDE = 'SET_MEDIUMGUIDE';
export function setMideumguide(mediumguide) {
    return({
        type:SET_MEDIUMGUIDE, mediumguide
    });
}

export const SET_MEDIUMNEWS = 'SET_MEDIUMNEWS';
export function setMideumNews(mediumNews) {
    return({
        type:SET_MEDIUMNEWS, mediumNews
    });
}

export const SET_LOADING = 'SET_LOADING';
export function setLoading(isLoading){
    return({
        type:SET_LOADING,
        isLoading
    });
}




// WEBPACK FOOTER //
// ./src/header/libs/action.js